export class LoginMovil {
    cfurCodigoBorrador: string;
    strCorreoDen: string;
    strFlgOlvidoClave: string;
    strCodVerificacion: string;
    cfurClavedenunc: string;

}

